import { render, staticRenderFns } from "./teaserView.vue?vue&type=template&id=646c8bd4&scoped=true&"
import script from "./teaserView.vue?vue&type=script&lang=js&"
export * from "./teaserView.vue?vue&type=script&lang=js&"
import style0 from "./teaserView.vue?vue&type=style&index=0&id=646c8bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c8bd4",
  null
  
)

export default component.exports